import axios from "axios";
import { baseUrl } from "./baseUrl";
import TokenService from "./token.service";

const NotificationAPI = () => {
  const { getToken, rememberGet } = TokenService();
  const token = getToken(rememberGet());
  let newToken = token;

  const getNotifications = (page) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/notifications/?page=${page}`,
      headers: {
        Authorization: `Bearer ${newToken}`,
        "Content-Type": "application/json",
      },
    };

    return axios.request(config);
  };

  const updateRead = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/notifications/read/${id}`,
      headers: {
        Authorization: `Bearer ${newToken}`,
        "Content-Type": "application/json",
      },
    };

    return axios.request(config);
  };

  return { updateRead, getNotifications };
};

export default NotificationAPI;
